import { gql } from "@apollo/client"

const SECTION_JOB_STEP_FIELDS = gql`
  fragment SectionJobStepFields on SectionJobStep {
    id
    step
    stepCount
    name
    description
    responseType
    notApplicable
    isCollapsedByDefault
    completed @client
    uploads {
      ...JobStepUploadsFields
    }
  }
`

export { SECTION_JOB_STEP_FIELDS }
